<template>
	<div class="pronto-spinner">
		<div v-for="x in bars" :key="x" :class="`bar${x}`" />
	</div>
</template>

<script>
const COUNT = 12

export default {
	name: 'Spinner',
	data() {
		return { bars: Array.from(Array(COUNT).keys()) }
	},
}
</script>

<style scoped lang="scss">
@keyframes fade {
	from {
		opacity: 1;
	}
	to {
		opacity: 0.25;
	}
}

.pronto-spinner {
	height: 1em;
	width: 1em;
	position: relative;
	display: inline-block;
	vertical-align: top;
	font-size: 30px;

	> div {
		width: 6%;
		height: 16%;
		background: currentColor;
		position: absolute;
		left: 49%;
		top: 43%;
		opacity: 0;
		border-radius: 50px;
		animation: fade 1s linear infinite;
	}

	@for $i from 0 through 11 {
		.bar#{$i} {
			transform: rotate(-#{$i * 30}deg) translate(0, -130%);
			animation-delay: #{0 - ($i * 0.0833)}s;
		}
	}
}
</style>
